module.exports = __webpack_public_path__ + "static/media/2024 FJCL Logo_1709044763430.de89bbd7.jpeg";